import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useState } from 'react';

/**
 * Управление открытием/закрытием модального окна через проверку hash в url
 */
export var useAnchorModal = function useAnchorModal(anchorKey, onView) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var clearHashUrl = useCallback(function () {
    window.history.replaceState({}, document.title, "".concat(window.location.pathname).concat(window.location.search));
  }, []);
  var handleOpenModal = useCallback(function () {
    if (window.location.hash === anchorKey) {
      setIsOpen(true);
      onView === null || onView === void 0 ? void 0 : onView();
    }
  }, []);
  var handleCloseModal = function handleCloseModal() {
    setIsOpen(false);
    clearHashUrl();
  };
  useEffect(function () {
    if (window.location.hash === anchorKey) clearHashUrl();
    window.addEventListener('hashchange', handleOpenModal);
    return function () {
      return window.removeEventListener('hashchange', handleOpenModal);
    };
  }, [handleOpenModal, clearHashUrl]);
  return {
    isOpen: isOpen,
    onClose: handleCloseModal
  };
};